import { ComponentStyleConfig } from "@chakra-ui/react";

const Blogpost: ComponentStyleConfig = {
	baseStyle: ({ breakpoint: bp }) => ({
		bottomElements: {
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			flexDir: { base: "column", [bp]: "row" },
			gap: 6,
		},
		previewTitle: {
			fontSize: "xl",
			textAlign: "left",
			fontFamily: "sans",
			fontWeight: 600,
			px: 3,
		},
		previewMetadata: {
			display: "flex",
			fontSize: "sm",
			bg: "brand.blue",
			py: 4,
			px: 3,
			color: "white",
		},
		previewTextWrapper: {
			display: "flex",
			flexDirection: "column",
			gap: 4,
			height: "calc(100% - 10rem)",
		},
		previewImageWrapper: {
			position: "relative",
			height: "10rem",
		},
		previewWrapper: {
			boxShadow: "drop",
			borderRadius: "md",
			overflow: "hidden",
			textAlign: "left",
			bg: "white",
			color: "brand.blue",
		},
		socialLinks: {
			display: "flex",
			justifyContent: { base: "center", [bp]: "start" },
			gap: { base: 10, lg: 8 },
		},
		authorImage: {
			width: 13,
			height: 13,
			overflow: "hidden",
			borderRadius: "100vw",
		},
		link: {
			color: "brand.blue",
			fontWeight: "medium",
			px: 3,
			pb: 4,
		},
	}),
};

export default Blogpost;
